/** True when built/served with --mode demo (.env.demo). Never set in prod builds. */
export const isDemoMode = (): boolean => import.meta.env.VITE_MODE === 'demo';

/** Static bearer token the demo session presents; MSW handlers ignore auth. */
export const DEMO_JWT = 'demo-session-jwt';

// Identity constants shared by the demo auth path (`useDemoAuth`, `demoSdk`)
// and the demo API mocks (`src/mocks/`). They live here rather than in
// `src/mocks/` because the auth path must not import the mock layer — that
// would pull MSW and every fixture into the production bundle.

/** The demo visitor's canonical user id. */
export const DEMO_USER_ID = 'demo-user-001';

/** The organization the demo visitor owns. */
export const DEMO_ORG_ID = 'demo-org-001';
